import { Routes } from "@angular/router";
import { myRequestsTabsResolver } from "./resolvers";

export const myRequestsRoutes: Routes = [
  {
    path: "",
    data: {
      customClass: "page-wrapper py-0 mt-4",
    },
    resolve: {
      tabs: myRequestsTabsResolver,
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        path: "my-company-request",
        title: "COMPANIES.MY_COMPANY_REQUEST",
        loadComponent: () => import("./pages/my-company-request/my-company-request.component").then((c) => c.MyCompanyRequestComponent),
      },
      {
        path: "my-membership-request",
        title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_REQUEST",
        loadComponent: () =>
          import("./pages/my-membership-request/my-membership-request.component").then((c) => c.MyMembershipRequestComponent),
      },
      {
        path: "my-membership-request/:transactionType",
        title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_REQUEST",
        loadComponent: () =>
          import("./pages/my-membership-request/my-membership-request.component").then((c) => c.MyMembershipRequestComponent),
      },
    ],
  },
  {
    path: "my-company-request/:id",
    title: "COMPANIES.MY_COMPANY_REQUEST_DETAILS",
    loadComponent: () =>
      import("./pages/my-company-request-details/my-company-request-details.component").then((c) => c.MyCompanyRequestDetailsComponent),
  },
];
